import Vue from 'vue';

export default Vue.extend({
    data: function() {
        return {
            showFilter: false
        };
    },
    beforeMount() {
        this.params.column.addEventListener(
            'filterChanged',
            function(params) {
                console.log(params);
                this.showFilter = params.column.isFilterActive();
                // when filter changes on the col, this will print one of [true,false]
                // console.log(
                //     'filter of column is ' + this.params.column.isFilterActive()
                // );
            }.bind(this)
        );
    },
    mounted() {},
    methods: {
        onMenuClicked() {
            this.params.showColumnMenu(this.$refs.eMenu);
        }
    },
    template: `
        <div class="ag-cell-label-container">
            <div class="ag-header-cell-label customHeaderLabel">
                <font-awesome-icon icon="user-edit"></font-awesome-icon>
                <span ref="eText" class="ag-header-cell-text" role="columnheader">
                    {{params.displayName}}
                </span>
                <span ref="eFilter" :hidden="!showFilter" class="ag-header-icon ag-filter-icon">
                    <span class="ag-icon ag-icon-filter"></span>
                </span>
                <span ref="eMenu" @click="onMenuClicked($event)" style="opacity: 0;" class="ag-header-icon ag-header-cell-menu-button">
                    <span class="ag-icon ag-icon-menu" unselectable="on"></span>
                </span>
            </div>

        </div>
    `
});



// WEBPACK FOOTER //
// ./src/views/my/planTemplate/components/customHeader.js